import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=f785285c&scoped=true&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"
import style0 from "./submenu.vue?vue&type=style&index=0&id=f785285c&prod&scoped=true&lang=css&"
import style1 from "./submenu.vue?vue&type=style&index=1&id=f785285c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f785285c",
  null
  
)

export default component.exports